import Pagination from 'pagination'

Pagination.config.event = {
    paging: 'ajax-form:page-update',
    update: 'ajax-form:after',
    reset: [ 'ajax-form:before', 'reset' ]
}
